/**
 * Enterprise vs Naturals salon UI + check-in sync for shared hair-analyzer pages.
 */
import React from 'react';
import { hairAppPath, resolveHairTenantPortal } from '../config/hairApp';
import { hasFranchiseFlowAuth as hasEnterpriseFranchiseFlowAuth, getFranchiseId as getEnterpriseFranchiseId } from '../../../../enterprise/shared/franchiseFlowAuth';
import { hasFranchiseFlowAuth as hasNaturalsFranchiseFlowAuth, getFranchiseId as getNaturalsFranchiseId } from '../../../../naturals/shared/franchiseFlowAuth';
import { hasFranchiseFlowAuth as hasNyafazEpFranchiseFlowAuth, getFranchiseId as getNyafazEpFranchiseId } from '../../../../nyafaz-ep/shared/franchiseFlowAuth';
import { resolveGuestUserDataForAnalysis as naturalsResolveGuestUserData } from '../../../../naturals/salon/utils/bootstrapFaceSalonSession';
import { resolveGuestUserDataForAnalysis as enterpriseResolveGuestUserData } from '../../../../enterprise/salon/utils/bootstrapFaceSalonSession';
import { resolveGuestUserDataForAnalysis as nyafazEpResolveGuestUserData } from '../../../../nyafaz-ep/salon/utils/bootstrapFaceSalonSession';
import { getSessionId as getNaturalsSalonVisitSessionId } from '../../../../naturals/salon/utils/sessionManager';
import { getSessionId as getEnterpriseSalonVisitSessionId } from '../../../../enterprise/salon/utils/sessionManager';
import { getSessionId as getNyafazEpSalonVisitSessionId } from '../../../../nyafaz-ep/salon/utils/sessionManager';
import { getSessionId as getHairAnalysisSessionId } from './sessionManager';
import { readVisitHandoff as naturalsReadVisitHandoff } from '../../../../naturals/salon/utils/visitHandoff';
import { readVisitHandoff as enterpriseReadVisitHandoff } from '../../../../enterprise/salon/utils/visitHandoff';
import { readVisitHandoff as nyafazEpReadVisitHandoff } from '../../../../nyafaz-ep/salon/utils/visitHandoff';

import EnterpriseFaceIdentityBrandLogo from '../../../../enterprise/face-identity/components/FaceIdentityBrandLogo';
import { useFaceIdentityOrgLogo as useEnterpriseFaceIdentityOrgLogo } from '../../../../enterprise/face-identity/hooks/useFaceIdentityOrgLogo';
import EnterpriseSalonHeaderActions from '../../../../enterprise/salon/components/SalonHeaderActions';
import { resolveExperienceHubPath as enterpriseResolveExperienceHubPath } from '../../../../enterprise/salon/utils/salonHomeNav';
import { isPresentationMode as enterpriseIsPresentationMode } from '../../../../enterprise/presentation/presentationSession';
import {
  buildTreatmentCartPayload as enterpriseBuildTreatmentCartPayload,
  persistProductCart as enterprisePersistProductCart,
  persistTreatmentCart as enterprisePersistTreatmentCart,
} from '../../../../enterprise/salon/utils/cartPersistence';
import {
  confirmAnalysisServicesAndStart as enterpriseConfirmAnalysisServicesAndStart,
  scheduleSyncAnalysisPendingServices as enterpriseScheduleSyncAnalysisPendingServices,
  syncAnalysisProductCartToCheckin as enterpriseSyncAnalysisProductCartToCheckin,
  syncAnalysisRecommendedProductsReady as enterpriseSyncAnalysisRecommendedProductsReady,
  treatmentCartToPendingServices as enterpriseTreatmentCartToPendingServices,
} from '../../../../enterprise/salon/utils/analysisServiceSync';
import { modernConfirm as enterpriseModernConfirm } from '../../../../enterprise/admin-shared/modernDialog';
import { readStoredFranchiseBrandName as enterpriseReadStoredFranchiseBrandName } from '../../../../enterprise/shared/franchiseBrand';
import EnterpriseReportPdfQrPanel from '../../../../enterprise/shared/ReportPdfQrPanel';

import NaturalsFaceIdentityBrandLogo from '../../../../naturals/face-identity/components/FaceIdentityBrandLogo';
import { useFaceIdentityOrgLogo as useNaturalsFaceIdentityOrgLogo } from '../../../../naturals/face-identity/hooks/useFaceIdentityOrgLogo';
import NaturalsSalonHeaderActions from '../../../../naturals/salon/components/SalonHeaderActions';
import { resolveExperienceHubPath as naturalsResolveExperienceHubPath } from '../../../../naturals/salon/utils/salonHomeNav';
import { isPresentationMode as naturalsIsPresentationMode } from '../../../../naturals/presentation/presentationSession';
import {
  buildTreatmentCartPayload as naturalsBuildTreatmentCartPayload,
  persistProductCart as naturalsPersistProductCart,
  persistTreatmentCart as naturalsPersistTreatmentCart,
} from '../../../../naturals/salon/utils/cartPersistence';
import {
  confirmAnalysisServicesAndStart as naturalsConfirmAnalysisServicesAndStart,
  scheduleSyncAnalysisPendingServices as naturalsScheduleSyncAnalysisPendingServices,
  syncAnalysisProductCartToCheckin as naturalsSyncAnalysisProductCartToCheckin,
  syncAnalysisRecommendedProductsReady as naturalsSyncAnalysisRecommendedProductsReady,
  treatmentCartToPendingServices as naturalsTreatmentCartToPendingServices,
} from '../../../../naturals/salon/utils/analysisServiceSync';
import { modernConfirm as naturalsModernConfirm } from '../../../../naturals/admin-shared/modernDialog';
import { readStoredFranchiseBrandName as naturalsReadStoredFranchiseBrandName } from '../../../../naturals/shared/franchiseBrand';
import NaturalsReportPdfQrPanel from '../../../../naturals/shared/ReportPdfQrPanel';

import NyafazEpFaceIdentityBrandLogo from '../../../../nyafaz-ep/face-identity/components/FaceIdentityBrandLogo';
import { useFaceIdentityOrgLogo as useNyafazEpFaceIdentityOrgLogo } from '../../../../nyafaz-ep/face-identity/hooks/useFaceIdentityOrgLogo';
import NyafazEpSalonHeaderActions from '../../../../nyafaz-ep/salon/components/SalonHeaderActions';
import { resolveAnalysisFlowHomePath as nyafazEpResolveAnalysisFlowHomePath } from '../../../../nyafaz-ep/salon/utils/salonHomeNav';
import { isPresentationMode as nyafazEpIsPresentationMode } from '../../../../nyafaz-ep/presentation/presentationSession';
import {
  buildTreatmentCartPayload as nyafazEpBuildTreatmentCartPayload,
  persistProductCart as nyafazEpPersistProductCart,
  persistTreatmentCart as nyafazEpPersistTreatmentCart,
} from '../../../../nyafaz-ep/salon/utils/cartPersistence';
import {
  confirmAnalysisServicesAndStart as nyafazEpConfirmAnalysisServicesAndStart,
  scheduleSyncAnalysisPendingServices as nyafazEpScheduleSyncAnalysisPendingServices,
  syncAnalysisProductCartToCheckin as nyafazEpSyncAnalysisProductCartToCheckin,
  syncAnalysisRecommendedProductsReady as nyafazEpSyncAnalysisRecommendedProductsReady,
  treatmentCartToPendingServices as nyafazEpTreatmentCartToPendingServices,
} from '../../../../nyafaz-ep/salon/utils/analysisServiceSync';
import { modernConfirm as nyafazEpModernConfirm } from '../../../../nyafaz-ep/admin-shared/modernDialog';
import { readStoredFranchiseBrandName as nyafazEpReadStoredFranchiseBrandName } from '../../../../nyafaz-ep/shared/franchiseBrand';
import NyafazEpReportPdfQrPanel from '../../../../nyafaz-ep/shared/ReportPdfQrPanel';

function isNyafazEpPortal() {
  return resolveHairTenantPortal() === 'nyafaz_ep';
}

function isNaturalsPortal() {
  return resolveHairTenantPortal() === 'naturals';
}

export function resolveHairSalonFlowDeps() {
  if (isNyafazEpPortal()) {
    return {
      FaceIdentityBrandLogo: NyafazEpFaceIdentityBrandLogo,
      SalonHeaderActions: NyafazEpSalonHeaderActions,
      resolveExperienceHubPath: nyafazEpResolveAnalysisFlowHomePath,
      isPresentationMode: nyafazEpIsPresentationMode,
      buildTreatmentCartPayload: nyafazEpBuildTreatmentCartPayload,
      persistProductCart: nyafazEpPersistProductCart,
      persistTreatmentCart: nyafazEpPersistTreatmentCart,
      confirmAnalysisServicesAndStart: nyafazEpConfirmAnalysisServicesAndStart,
      scheduleSyncAnalysisPendingServices: nyafazEpScheduleSyncAnalysisPendingServices,
      syncAnalysisProductCartToCheckin: nyafazEpSyncAnalysisProductCartToCheckin,
      syncAnalysisRecommendedProductsReady: nyafazEpSyncAnalysisRecommendedProductsReady,
      treatmentCartToPendingServices: nyafazEpTreatmentCartToPendingServices,
      modernConfirm: nyafazEpModernConfirm,
      readStoredFranchiseBrandName: nyafazEpReadStoredFranchiseBrandName,
      ReportPdfQrPanel: NyafazEpReportPdfQrPanel,
    };
  }
  if (isNaturalsPortal()) {
    return {
      FaceIdentityBrandLogo: NaturalsFaceIdentityBrandLogo,
      SalonHeaderActions: NaturalsSalonHeaderActions,
      resolveExperienceHubPath: naturalsResolveExperienceHubPath,
      isPresentationMode: naturalsIsPresentationMode,
      buildTreatmentCartPayload: naturalsBuildTreatmentCartPayload,
      persistProductCart: naturalsPersistProductCart,
      persistTreatmentCart: naturalsPersistTreatmentCart,
      confirmAnalysisServicesAndStart: naturalsConfirmAnalysisServicesAndStart,
      scheduleSyncAnalysisPendingServices: naturalsScheduleSyncAnalysisPendingServices,
      syncAnalysisProductCartToCheckin: naturalsSyncAnalysisProductCartToCheckin,
      syncAnalysisRecommendedProductsReady: naturalsSyncAnalysisRecommendedProductsReady,
      treatmentCartToPendingServices: naturalsTreatmentCartToPendingServices,
      modernConfirm: naturalsModernConfirm,
      readStoredFranchiseBrandName: naturalsReadStoredFranchiseBrandName,
      ReportPdfQrPanel: NaturalsReportPdfQrPanel,
    };
  }
  return {
    FaceIdentityBrandLogo: EnterpriseFaceIdentityBrandLogo,
    SalonHeaderActions: EnterpriseSalonHeaderActions,
    resolveExperienceHubPath: enterpriseResolveExperienceHubPath,
    isPresentationMode: enterpriseIsPresentationMode,
    buildTreatmentCartPayload: enterpriseBuildTreatmentCartPayload,
    persistProductCart: enterprisePersistProductCart,
    persistTreatmentCart: enterprisePersistTreatmentCart,
    confirmAnalysisServicesAndStart: enterpriseConfirmAnalysisServicesAndStart,
    scheduleSyncAnalysisPendingServices: enterpriseScheduleSyncAnalysisPendingServices,
    syncAnalysisProductCartToCheckin: enterpriseSyncAnalysisProductCartToCheckin,
    syncAnalysisRecommendedProductsReady: enterpriseSyncAnalysisRecommendedProductsReady,
    treatmentCartToPendingServices: enterpriseTreatmentCartToPendingServices,
    modernConfirm: enterpriseModernConfirm,
    readStoredFranchiseBrandName: enterpriseReadStoredFranchiseBrandName,
    ReportPdfQrPanel: EnterpriseReportPdfQrPanel,
  };
}

export function HairSalonBrandLogo(props) {
  const { FaceIdentityBrandLogo } = resolveHairSalonFlowDeps();
  return <FaceIdentityBrandLogo {...props} />;
}

export function useHairSalonOrgLogo() {
  const ent = useEnterpriseFaceIdentityOrgLogo();
  const nat = useNaturalsFaceIdentityOrgLogo();
  const ep = useNyafazEpFaceIdentityOrgLogo();
  if (isNyafazEpPortal()) return ep;
  return isNaturalsPortal() ? nat : ent;
}

const flow = resolveHairSalonFlowDeps();

export const {
  SalonHeaderActions,
  resolveExperienceHubPath,
  isPresentationMode,
  buildTreatmentCartPayload,
  persistProductCart,
  persistTreatmentCart,
  confirmAnalysisServicesAndStart,
  scheduleSyncAnalysisPendingServices,
  syncAnalysisProductCartToCheckin,
  syncAnalysisRecommendedProductsReady,
  treatmentCartToPendingServices,
  modernConfirm,
  readStoredFranchiseBrandName,
  ReportPdfQrPanel,
} = flow;

function hasHairSalonFranchiseAuth() {
  if (isNyafazEpPortal()) return hasNyafazEpFranchiseFlowAuth();
  if (isNaturalsPortal()) return hasNaturalsFranchiseFlowAuth();
  return hasEnterpriseFranchiseFlowAuth();
}

/** Salon kiosk / presentation → experience hub; standalone hair app → session landing. */
export function resolveHairFlowHomePath(sessionLandingPath = '') {
  if (hasHairSalonFranchiseAuth() || isPresentationMode()) {
    return resolveHairSalonFlowDeps().resolveExperienceHubPath();
  }
  return sessionLandingPath || hairAppPath('/landing');
}

export function navigateHairFlowHome(navigate, sessionLandingPath = '') {
  navigate(resolveHairFlowHomePath(sessionLandingPath));
}

export function resolveHairGuestUserDataForAnalysis(locationState) {
  if (isNyafazEpPortal()) return nyafazEpResolveGuestUserData(locationState);
  return isNaturalsPortal()
    ? naturalsResolveGuestUserData(locationState)
    : enterpriseResolveGuestUserData(locationState);
}

export function getHairSalonFranchiseId() {
  if (isNyafazEpPortal()) return getNyafazEpFranchiseId();
  return isNaturalsPortal() ? getNaturalsFranchiseId() : getEnterpriseFranchiseId();
}

/** Salon visit skin_id for cart/check-in sync (not Hair Insight HA-* session). */
export function resolveHairSalonVisitSessionId() {
  const readHandoff = isNyafazEpPortal()
    ? nyafazEpReadVisitHandoff
    : isNaturalsPortal()
      ? naturalsReadVisitHandoff
      : enterpriseReadVisitHandoff;
  const salonSid = String(
    (isNyafazEpPortal()
      ? getNyafazEpSalonVisitSessionId()
      : isNaturalsPortal()
        ? getNaturalsSalonVisitSessionId()
        : getEnterpriseSalonVisitSessionId()) || '',
  ).trim();
  if (salonSid && !salonSid.toUpperCase().startsWith('HA-')) {
    return salonSid;
  }
  const handoff = readHandoff() || {};
  const fromHandoff = String(
    handoff.visitReference || handoff.salonReference || handoff.salon_reference || '',
  ).trim();
  if (fromHandoff && !fromHandoff.toUpperCase().startsWith('HA-')) {
    return fromHandoff;
  }
  const hairSid = String(getHairAnalysisSessionId() || '').trim();
  if (hairSid && !hairSid.toUpperCase().startsWith('HA-')) {
    return hairSid;
  }
  return salonSid || fromHandoff || hairSid || null;
}
